import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import 'Components/Ebook/EbookTrustBar.scss';

const EbookTrustBar = ({ whiteTheme, mixedBundle, downloadTypes, slug, drm }) => {
  let showFileTypes = true;
  if (slug === 'deathlands-sci-fi-novels-bundle' || slug === 'rogue-angel-fantasy-novels-bundle') {
    showFileTypes = false;
  }
  if (drm[0] === 'idw' || drm[0] === 'drivethrurpg') {
    showFileTypes = false;
  }

  const showDrmFree = (isEmpty(drm) || drm[0] === 'drm_free');

  return (
    <div
      className={
        classNames(
          'ebooks-trust-container',
          { 'banner-white-theme': whiteTheme },
          { 'three-trust-items': !showDrmFree },
          { 'four-trust-items': showDrmFree },
        )
      }
    >
      <article className="ebook-trust-item">
        <div className="icon-container">
          <img
            src="https://cdn.fanatical.com/production/icons/slim-icons/brand-icons/face-happy.svg"
            alt="Lifetime Ownership"
          />
        </div>
        <div className="text-container">
          <h3 className="ebook-trust-header">
            <FormattedMessage id="ebooks-trust-bar.trustheader" defaultMessage="Lifetime Ownership" />
          </h3>
          <div>
            {!mixedBundle &&
              <FormattedMessage id="ebooks-trust-bar.trusttext" defaultMessage="Download and keep your eBooks forever." />
            }
            {mixedBundle &&
              <FormattedMessage id="ebooks-trust-bar.trusttext.mixed" defaultMessage="Download and keep your products forever." />
            }
          </div>
        </div>
      </article>

      <article className="ebook-trust-item">
        <div className="icon-container">
          <img
            src="https://cdn.fanatical.com/production/icons/slim-icons/brand-icons/shopping-cart-quick.svg"
            alt="Instant Delivery"
          />
        </div>
        <div className="text-container">
          <h3 className="ebook-trust-header">
            <FormattedMessage id="ebooks-trust-bar.trustheadertwo" defaultMessage="Instant Delivery" />
          </h3>
          <div>
            {!mixedBundle &&
              <FormattedMessage id="ebooks-trust-bar.trusttexttwo" defaultMessage="Your eBooks are available to read in minutes." />
            }
            {mixedBundle &&
              <FormattedMessage id="ebooks-trust-bar.trusttexttwo.mixed" defaultMessage="Your products are available in minutes." />
            }
          </div>
        </div>
      </article>

      {showFileTypes &&
        <article className="ebook-trust-item">
          <div className="icon-container">
            <img
              src="https://cdn.fanatical.com/production/icons/slim-icons/brand-icons/book-download.svg"
              alt="Multiple File Types"
            />
          </div>
          {downloadTypes && downloadTypes.length === 1 &&
            <div className="text-container">
              <h3 className="ebook-trust-header">
                <FormattedMessage
                  id="ebooks-trust-bar.trustheaderthree.single"
                  defaultMessage="{fileType} file types"
                  values={{
                    fileType: downloadTypes[0],
                  }}
                />
              </h3>
              <div>
                <FormattedMessage
                  id="ebooks-trust-bar.trusttextthree.single"
                  defaultMessage="All your eBooks are provided as {fileType}."
                  values={{
                    fileType: <span><span className="text-uppercase">{downloadTypes[0]}</span>s</span>,
                  }}
                />
              </div>
            </div>
          }
          {(isEmpty(downloadTypes) || downloadTypes.length > 1) &&
            <div className="text-container">
              <h3 className="ebook-trust-header">
                <FormattedMessage id="ebooks-trust-bar.trustheaderthree" defaultMessage="Multiple file types" />
              </h3>
              <div>
                {!mixedBundle &&
                  <FormattedMessage id="ebooks-trust-bar.trusttextthree" defaultMessage="You choose how you want to read your eBooks." />
                }
                {mixedBundle &&
                  <FormattedMessage id="ebooks-trust-bar.trusttextthree.mixed" defaultMessage="You choose how you want to view your files." />
                }
              </div>
            </div>
          }
        </article>
      }
      {(isEmpty(drm) || drm[0] === 'drm_free') &&
        <article className="ebook-trust-item">
          <div className="icon-container">
            <img
              src="https://cdn.fanatical.com/production/icons/slim-icons/brand-icons/shield-confirm.svg"
              alt="DRM Free"
            />
          </div>
          <div className="text-container">
            <h3 className="ebook-trust-header">
              <FormattedMessage id="ebooks-trust-bar.trustheaderfour" defaultMessage="DRM Free" />
            </h3>
            <div>
              <FormattedMessage id="ebooks-trust-bar.trusttextfour" defaultMessage="All eBooks are DRM free." />
            </div>
          </div>
        </article>
      }
      {drm[0] === 'idw' &&
        <article className="ebook-trust-item">
          <div className="icon-container">
            <img
              src="https://cdn.fanatical.com/production/icons/slim-icons/brand-icons/shield-confirm.svg"
              alt="Easy Redemption"
            />
          </div>
          <div className="text-container">
            <h3 className="ebook-trust-header">
              <FormattedMessage id="ebooks-trust-bar.trustheaderidw" defaultMessage="Easy Redemption" />
            </h3>
            <div>
              <FormattedMessage id="ebooks-trust-bar.trusttextidw" defaultMessage="Redeem on the free IDW app." />
            </div>
          </div>
        </article>
      }
      {drm[0] === 'drivethrurpg' &&
        <article className="ebook-trust-item">
          <div className="icon-container">
            <img
              src="https://cdn.fanatical.com/production/icons/slim-icons/brand-icons/shield-confirm.svg"
              alt="Easy Redemption"
            />
          </div>
          <div className="text-container">
            <h3 className="ebook-trust-header">
              <FormattedMessage id="ebooks-trust-bar.trustheaderdrivethrurpg" defaultMessage="Easy Redemption" />
            </h3>
            <div>
              <FormattedMessage id="ebooks-trust-bar.trusttextdrivethrurpg" defaultMessage="Redeem through DriveThruRPG." />
            </div>
          </div>
        </article>
      }
    </div>
  );
};

EbookTrustBar.propTypes = {
  whiteTheme: PropTypes.bool,
  mixedBundle: PropTypes.bool,
  downloadTypes: PropTypes.arrayOf(PropTypes.string),
  slug: PropTypes.string,
  drm: PropTypes.string,
};

EbookTrustBar.defaultProps = {
  whiteTheme: false,
  mixedBundle: false,
  downloadTypes: [],
  slug: '',
  drm: '',
};

export default EbookTrustBar;
